import { render, staticRenderFns } from "./SVG-Ellipse.vue?vue&type=template&id=2c7284fc&scoped=true&"
import script from "./SVG-Ellipse.vue?vue&type=script&lang=js&"
export * from "./SVG-Ellipse.vue?vue&type=script&lang=js&"
import style0 from "./SVG-Ellipse.vue?vue&type=style&index=0&id=2c7284fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7284fc",
  null
  
)

export default component.exports